import { render } from "./selectTemplate.vue?vue&type=template&id=028bf870&scoped=true"
import script from "./selectTemplate.vue?vue&type=script&lang=js"
export * from "./selectTemplate.vue?vue&type=script&lang=js"

import "./selectTemplate.vue?vue&type=style&index=0&id=028bf870&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028bf870"]])

export default __exports__